import { useSelector } from 'react-redux'
import { getAreaInfoById } from '@/store/slices/stagesSlice/stagesSlice'
import { RootState } from '@/store'
import { AreaPageHeader } from '@/components/pages/AreaPageModern/components/AreaPageHeader/AreaPageHeader'
import { AreaPageMain } from '@/components/pages/AreaPageModern/components/AreaPageMain/AreaPageMain'
import { AreaPageFooter } from '@/components/pages/AreaPageModern/components/AreaPageFooter/AreaPageFooter'
import styles from './AreaPageModern.module.scss'

export default function AreaPageModern({ id }: { id: string }) {
  const reduxState = useSelector<RootState, RootState>(state => state)
  const { data: area } = getAreaInfoById(reduxState, id)

  return (
    <div className={styles.page}>
      <div className={styles.page__content}>
        <AreaPageHeader />
        <AreaPageMain area={area} areaId={id} />
        <AreaPageFooter links={area?.footer_links} />
      </div>
    </div>
  )
}
